import { serverApi } from "./serverApi";
import { StatusCode } from "../types/sharedTypes";

export const statusCodeService = serverApi.injectEndpoints({
  endpoints: (build) => ({
    getAllStatusCode: build.query<Array<StatusCode>, string>({
      query: () => ({
        url: "/status-codes/all-status-codes"
      })
    })
  })
});

export const {
  useGetAllStatusCodeQuery
} = statusCodeService;